module.exports = __webpack_public_path__ + "img/wangweimang.772f998e.jpg";